import React, { useEffect, useState } from 'react';
import '../styles/HeaderStyle.css'
import { onAuthStateChanged, getAuth } from 'firebase/auth';

function LoginLogout() {

    const [isLoggedIn, setIsLoggedIn] = useState(false);
    //const [user, setUser] = useState(null);

    const auth = getAuth();
      
    useEffect(() => {
    // This returns an unsubscribe function
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsLoggedIn(!!user);
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, [auth]);

      async function handleLogout() { 
        try {
            await auth.signOut();
        } catch (error) {
            console.log("error")
        }
  }

      return (
    <div>
      {isLoggedIn ? (
        <button id='logoutButton' onClick={handleLogout}>Logout</button>
      ) : (
        <a id='loginButton' href='/login'>Login</a>
      )}
    </div>
  );

}
export default LoginLogout
